import { render, staticRenderFns } from "./PartnerSelection.vue?vue&type=template&id=1a163f0f&scoped=true&"
import script from "./PartnerSelection.vue?vue&type=script&lang=ts&"
export * from "./PartnerSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a163f0f",
  null
  
)

export default component.exports